import { c as _c } from "react/compiler-runtime";
import { FeatherAlertCircle } from '@subframe/core';
import { AgentParametersFields } from '@/shared/components/features/agentParametersFields';
import { Button } from '@/shared/components/ui';
import type { CamposDeInicioProps } from '../types';

/** Bloco "Dados para iniciar" do mock do #1333, com os estados de carga e de falha dele. */
export const CamposDeInicio = t0 => {
  const $ = _c(14);
  const {
    situacao,
    descricao,
    textoSemAgente,
    variables,
    valores,
    errors,
    onChange,
    onRecarregar
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className="text-heading-3 font-heading-3 text-default-font">Dados para iniciar</h3>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== descricao) {
    t2 = <p className="text-body text-subtext-color mt-1">{descricao}</p>;
    $[1] = descricao;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== errors || $[4] !== onChange || $[5] !== onRecarregar || $[6] !== situacao || $[7] !== textoSemAgente || $[8] !== valores || $[9] !== variables) {
    t3 = <div data-dd-privacy="mask" className="mt-5">{situacao === "sem-agente" ? <p className="text-body text-subtext-color">{textoSemAgente}</p> : situacao === "carregando" ? <div className="flex flex-col gap-3" aria-label={"Carregando par\xE2metros do agente"}>{Array.from({
          length: 2
        }).map(_temp)}</div> : situacao === "erro" ? <div role="alert" className="text-error-600 flex flex-wrap items-center gap-3"><FeatherAlertCircle /><span>Não foi possível carregar os dados deste agente.</span><Button variant="neutral-secondary" onClick={onRecarregar}>Tentar novamente</Button></div> : situacao === "sem-campos" ? <p className="text-body text-subtext-color">Este agente não solicita parâmetros adicionais para iniciar.</p> : <AgentParametersFields variables={variables} values={valores} errors={errors} onChange={onChange} />}</div>;
    $[3] = errors;
    $[4] = onChange;
    $[5] = onRecarregar;
    $[6] = situacao;
    $[7] = textoSemAgente;
    $[8] = valores;
    $[9] = variables;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="mt-6 border-t border-solid border-neutral-200 pt-6">{t1}{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp(_, index) {
  return <div key={index} className="h-12 animate-pulse rounded-[8px] bg-neutral-100" />;
}